<template>
  <b-form-group :label="field.label" :label-for="`${field.key}Input`" :description="field.description">

    <b-form-checkbox v-if="[ 'boolean', 'checkbox' ].includes(field.type)" :id="`${field.key}Input`"
      :checked="value" :disabled="field.disabled" @change="value => $emit('input', value)"/>

    <b-form-textarea v-else-if="[ 'multiline-string', 'textarea' ].includes(field.type)"
      :disabled="field.disabled" :id="`${field.key}Input`" rows="2" no-resize :placeholder="field.placeholder"
      :value="value" @input="value => $emit('input', value || null)"/>

    <b-form-tags v-else-if="[ 'string[]' ].includes(field.type)"
      add-button-variant="outline-primary" tag-variant="primary"
      :disabled="field.disabled" :id="`${field.key}Input`" :placeholder="field.placeholder"
      :value="Array.isArray(value) ? value : []"
      @input="value => $emit('input', Array.isArray(value) && value.length ? value : null)"/>

    <b-form-input v-else-if="[ 'string' ].includes(field.type)"
      :disabled="field.disabled" :id="`${field.key}Input`" :placeholder="field.placeholder"
      :value="value" @input="value => $emit('input', value || null)"/>

    <b-form-select v-else-if="[ 'enum', 'select' ].includes(field.type)"
      :disabled="field.disabled" :id="`${field.key}Input`" :placeholder="field.placeholder"
      :options="typeof field.options === 'function' ? field.options.call(this) : field.options"
      :value="value" @input="value => $emit('input', value)">
        <template v-if="field.empty" v-slot:first>
          <option :value="null">-- {{ field.empty }} --</option>
        </template>
    </b-form-select>

    <ordered-checkbox-group v-else-if="[ 'ordered-checkbox-group' ].includes(field.type)"
      :disabled="field.disabled" :id="`${field.key}Input`" :placeholder="field.placeholder"
      :options="typeof field.options === 'function' ? field.options.call(this) : field.options"
      :value="value" @input="value => $emit('input', value)"/>

    <chrome-picker v-else-if="['colorPicker'].includes(field.type)"
      disable-alpha :value="value || field.defaultValue" @input="({ hex }) => $emit('input', hex || null)" />

  </b-form-group>
</template>

<script>
import OrderedCheckboxGroup from '@src/components/forms/OrderedCheckboxGroup';
import { Chrome as ChromePicker } from 'vue-color';

export default {
  props: {
    field: Object,
    value: {
      default: () => null,
    },
  },
  components: {
    ChromePicker,
    OrderedCheckboxGroup,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/InputBlock.vue